import * as React from 'react';
// work around mui customization limitations (with react-router-dom)
export const ExternalLink = (props: any) => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a target="_blank" {...props}></a>;
};
